import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const FrameIcon: FC<IconProps> = ({ ...props }) => (
  <BaseIcon {...props}>
    <path d="M4 6a2 2 0 0 1 2-2h4a1 1 0 1 1 0 2H6v4a1 1 0 1 1-2 0V6Zm0 20a2 2 0 0 0 2 2h4a1 1 0 1 0 0-2H6v-4a1 1 0 1 0-2 0v4ZM26 4a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0V6h-4a1 1 0 1 1 0-2h4Zm2 22a2 2 0 0 1-2 2h-4a1 1 0 1 1 0-2h4v-4a1 1 0 1 1 2 0v4Zm-13.5-5a6.47 6.47 0 0 0 3.835-1.251l3.2 3.2a1 1 0 1 0 1.415-1.414l-3.201-3.2A6.5 6.5 0 1 0 14.5 21Zm0-2a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z" />
  </BaseIcon>
);
